import React, { KeyboardEvent, useState } from "react";
import "./App.css";
import Line from "./components/Line";
import {
  moveMatrixLeft,
  moveMatrixRight,
  moveMatrixUp,
  moveMatrixDown,
  addRandomTile,
  isGameOver,
} from "./functions/matrixUtils";

function getRandomNumber(n: number): number {
  return Math.floor(Math.random() * n) + 1;
}

function App() {
  const initialMatrix: number[][] = [
    [2, 2, 0, 2],
    [2, 2, 0, 2],
    [2, 2, 0, 2],
    [2, 2, 0, 2],
  ];

  const [matrix, setMatrix] = useState<number[][]>(initialMatrix);
  const [count, setCount] = useState(4);
  const [gameOver, setGameOver] = useState(false);

  function handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    if (gameOver) {
      return;
    }

    let newMatrix: number[][] = matrix;
    if (event.key === "ArrowLeft") {
      newMatrix = moveMatrixLeft(matrix);
    } else if (event.key === "ArrowRight") {
      newMatrix = moveMatrixRight(matrix);
    } else if (event.key === "ArrowUp") {
      newMatrix = moveMatrixUp(matrix);
    } else if (event.key === "ArrowDown") {
      newMatrix = moveMatrixDown(matrix);
    } else {
      return; // Ignore other keys
    }

    // Check if the move actually changed the matrix
    const matrixChanged = JSON.stringify(matrix) !== JSON.stringify(newMatrix);

    if (matrixChanged) {
      // Add a random tile after the move
      newMatrix = addRandomTile(newMatrix);

      // Check if game is over
      if (isGameOver(newMatrix)) {
        setGameOver(true);
      }

      setMatrix(newMatrix);
    }
  }

  function updateCount(count: number) {
    setCount(count);
    const newMatrix = [];
    for (let i = 0; i < count; i++) {
      const line = [];
      for (let j = 0; j < count; j++) {
        line.push(0);
      }
      newMatrix.push(line);
    }
    const dice1 = getRandomNumber(count - 1);
    const dice2 = getRandomNumber(count - 1);
    if (newMatrix.length > dice1 && newMatrix[dice1].length > dice2) {
      newMatrix[dice1][dice2] = 2;
      newMatrix[dice2][dice1] = 2;
    }
    setMatrix(newMatrix);
    setGameOver(false);
  }

  function restartGame() {
    const newMatrix = [];
    for (let i = 0; i < count; i++) {
      const line = [];
      for (let j = 0; j < count; j++) {
        line.push(0);
      }
      newMatrix.push(line);
    }
    const dice1 = getRandomNumber(count - 1);
    const dice2 = getRandomNumber(count - 1);
    newMatrix[dice1][dice2] = 2;
    newMatrix[dice2][dice1] = 2;
    setMatrix(newMatrix);
    setGameOver(false);
  }

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title">2048</h1>
        <p className="game-subtitle">Join the tiles, get to 2048!</p>
      </div>

      <div className="controls">
        <label htmlFor="grid-size">Grid Size:</label>
        <input
          id="grid-size"
          type="number"
          value={count}
          onChange={(e) => updateCount(+e.currentTarget.value)}
          min="3"
          max="8"
        />
        <button onClick={restartGame} className="restart-button">
          Restart Game
        </button>
      </div>

      <div className="App" onKeyDown={handleKeyDown} tabIndex={0}>
        {matrix.map((x, i) => (
          <Line cells={x} key={i} />
        ))}
      </div>

      {gameOver && (
        <div className="game-over-message">
          <p>Game Over! No more moves available.</p>
          <button onClick={restartGame} className="restart-button">
            Try Again
          </button>
        </div>
      )}

      <div className="instructions">
        <p>
          <strong>How to play:</strong> Use arrow keys to move tiles.
        </p>
        <p>When two tiles with the same number touch, they merge into one!</p>
      </div>
    </div>
  );
}

export default App;
